<template>
  <div v-html="footerHtml"></div>
</template>

<script>
  export default {
    data: function () {
      return {
        footerHtml: ''
      }
    },
    methods: {
      normalizeAssetPaths: function (html, baseUrl) {
        var parser = new DOMParser()
        var doc = parser.parseFromString(html, 'text/html')
        var attrs = ['src', 'href', 'data-base-src']
        attrs.forEach(function (attr) {
          var nodes = doc.querySelectorAll('[' + attr + ']')
          nodes.forEach(function (node) {
            var val = node.getAttribute(attr)
            if (!val) return
            if (val.startsWith('/') || val.startsWith('http') || val.startsWith('#') || val.startsWith('tel:') || val.startsWith('mailto:')) {
              return
            }
            node.setAttribute(attr, baseUrl + val)
          })
        })
        return doc.body.innerHTML
      }
    },
    mounted: function () {
      var baseUrl = process.env.BASE_URL || '/'
      fetch(baseUrl + 'footer.html')
        .then(function (res) {
          if (!res.ok) {
            throw new Error('footer.html load failed: ' + res.status)
          }
          return res.text()
        })
        .then(function (html) {
          this.footerHtml = this.normalizeAssetPaths(html, baseUrl)
        }.bind(this))
        .catch(function (e) {
          console.error(e)
        })
    }
  }
</script>
